import { render, staticRenderFns } from "./StrategyPushMgt.vue?vue&type=template&id=c871ed68&scoped=true"
import script from "./StrategyPushMgt.vue?vue&type=script&lang=js"
export * from "./StrategyPushMgt.vue?vue&type=script&lang=js"
import style0 from "./StrategyPushMgt.vue?vue&type=style&index=0&id=c871ed68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c871ed68",
  null
  
)

export default component.exports